// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"7687c967","182":"4e236fc4","209":"dce419be","375":"32eb7b16","403":"7745c56b","508":"f89e98cd","631":"0aff4e6b","851":"3f0086ba"}[chunkId] + ".chunk.js";
};